exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lista-empresa{\r\n    color: #f3c629;\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.sublista-empresa{\r\n    list-style-type: disc;\r\n}\r\n\r\n.renglon-padding{\r\n    text-indent: 30px;\r\n}\r\n\r\n.container-empresa{\r\n    margin-top: 10rem;\r\n}\r\n\r\n\r\n.texto-empresa{\r\n    color: white;\r\n    font-size: 1rem;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/componentes/empresa/empresa.component.css
// module id = ../../../../../src/app/componentes/empresa/empresa.component.css
// module chunks = 1